import React, { useEffect, useRef, useState } from 'react';
import { $ } from "react-jquery-plugin";
import { savePDF } from '@progress/kendo-react-pdf';
import { Grid, Text } from '@nextui-org/react';
import jsPDF from 'jspdf';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import axios from "axios";
import { schoolsurl } from '../../apis/urls';


const CheckPaymentPDF =()=> {

    const pdfRef = useRef(null);

    const todays = new Date();

    const {sname, assname, count} = useParams();
    const [pdfDatas, setPdfDatas] = useState([])
    const [schoolName, setSchoolName] = useState('');
    const [formattedDate, setformattedDate] = useState([])
    const [formattedTime, setformattedTime] = useState([])
    const [schoolId, setSchoolId] = useState(0);
    useEffect(() => {

        $('html,body').animate({ scrollTop: 0 }, 'fast');

        console.log("certificate from use effect");
        $('body').removeClass('').addClass('sidebar-collapsed');
        
        let datas = JSON.parse(localStorage.getItem("pdfData"))
        setPdfDatas(datas)
        console.log("data is",datas);
        
       
        let originalDateTime = datas.startdate;
        let originalMoment = moment(originalDateTime, 'YYYY-MM-DD HH:mm:ss');
        let dateTimeBefore24Hours = originalMoment.subtract(24, 'hours');
        let formattedDateTime = dateTimeBefore24Hours.format('YYYY-MM-DD HH:mm:ss');
        let formattedDate = moment(formattedDateTime).format('MMMM DD, YYYY');
        let formattedTime = moment(formattedDateTime).format('hh:mm A');
        setformattedDate(formattedDate);
        setformattedTime(formattedTime);
       
      

        const content = pdfRef.current;

        const doc = new jsPDF('p', 'mm', 'a4');
        doc.html(content, {
            callback: function (doc) {
                doc.save('payment_form.pdf');
            },
            html2canvas: { scale: 0.353 } 
        });
        
        setTimeout(()=>{
            localStorage.removeItem('pdfData')
        }, 5000)
        
    },[]);

    return (
    <div className="wrapper">
        <aside className="right-side ">
            <div style={{ padding:"50px"}} className="content-area no-header pdf-association">
                <div className='association-pdf' ref={pdfRef}>   
                 
                   
                    <div style={{display: 'flex',justifyContent: 'space-between',alignItems: 'center'}}>
                        <div  style={{ textAlign: 'left' ,marginTop:"20px",marginLeft:"5px"}}>
                            <img src={require('../../images/logo.jpg')} style={{width:'auto'}} className="form-image" alt=''/>
                        </div>  
                    </div>
                    <hr style={{ width: '100%', borderTop: '1px solid #000' }} />

                    

                    <div style={{marginBottom:"20px",fontSize:'18px', fontWeight:'bold', textTransform:'uppercase', marginLeft:"25px" ,textAlign: 'left'}}><b>{pdfDatas?.eventname}</b></div>
                    <div style={{fontSize:'14px', fontWeight:'bold', marginLeft:"25px",textAlign: 'left'}}><b>{moment(pdfDatas.startdate).format('dddd, MMMM DD, YYYY')}</b></div>
                    <div style={{fontSize:'14px', fontWeight:'bold', marginLeft:"25px" ,textAlign: 'left'}}><b>{moment(pdfDatas.startdate).format('hh:mm A')}</b></div>
                    <div style={{marginBottom:"20px",fontSize:'14px', fontWeight:'bold', marginLeft:"25px" ,textAlign: 'left'}}>At {pdfDatas.location}</div>
                    
                    <div style={{fontSize:'14px', fontWeight:'bold', marginLeft:"25px" , textAlign: 'left'}}><b>24 hour Cancellation Policy </b>:</div>
                    <div style={{ marginLeft:"25px" , textAlign: 'left'}}>Must cancel before {formattedTime} on {formattedDate}, to receive a refund.</div>
                    <div style={{ marginLeft:"25px" , textAlign: 'left',marginBottom:"20px"}}>No refunds for NO SHOWS .</div>
                    
                    <div className="row">
                        <div  className="col-md-4" style={{ marginLeft:"25px",marginBottom:"15px"}}><b>{pdfDatas.schoolid === "Non-member school" ? pdfDatas.orgname : pdfDatas.schoolnameis}</b></div>
                        <div className="col-md-2" style={{ marginLeft:"25px"}}></div>
                        <div className="col-md-3" style={{marginBottom:"15px"}}><b>Cost</b></div>
                    </div>
                    
                    

                    
                        { pdfDatas?.attendees?.map((item,index)=>( 
                            <div className="row" key={index}>
                                <div className="col-md-4" style={{ marginLeft:"25px"}}>{item.firstname}</div>
                                <div className="col-md-2" style={{ marginLeft:"25px"}}></div>
                                <div className="col-md-3" style={{marginBottom:"15px"}}>${pdfDatas?.amount}</div>
                            </div>
                         ))}
                   
                    <div class="row">
                        <div className="col-md-4" style={{ marginLeft:"25px"}}><b>Grand Total</b></div>
                        <div className="col-md-2" style={{ marginLeft:"25px"}}></div>
                        <div className="col-md-3" style={{marginBottom:"20px"}}><b>${pdfDatas?.amount * pdfDatas?.attendee}</b></div>
                    </div>


                    <div style={{marginLeft:"25px",marginBottom:"20px"}}>Registered on  {moment(todays).format('MM-DD-YYYY HH:mm:ss')} . </div>
                    <div  style={{marginLeft:"25px",marginBottom:"20px",whiteSpace: "pre-line" }}>Please &nbsp;remit payment by CHECK&nbsp;&nbsp;  for ${pdfDatas?.amount * pdfDatas?.attendee} payable to GISA&nbsp;  and mail within 7 business &nbsp;&nbsp; days to confirm your registration. </div>

                    
                    <div style={{marginLeft:"25px"}}>Mail to :</div>
                    <div style={{marginLeft:"25px"}}>GISA</div>
                    <div style={{marginLeft:"25px"}}>PO Box 9</div>
                    <div style={{marginLeft:"25px",marginBottom:"20px"}}>Dawsonville, GA 30534</div>

                    <div style={{marginLeft:"25px",marginBottom:"20px"}}>If you have any questions about your registration, please contact the GISA &nbsp;&nbsp;Office at (706) 938-1400 or Email Robin Aylor at robin@gisaschools.org.  </div>

                    <div style={{marginLeft:"25px"}}>Thank You .</div>

                </div>
            </div>
        </aside>
    </div>
    )
}

export default CheckPaymentPDF 